import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { METRICS } from '../data/mockData';
const container = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const item = {
  hidden: {
    opacity: 0,
    y: 20
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      type: 'spring',
      stiffness: 300,
      damping: 24
    }
  }
};
export function MetricCards() {
  return <motion.div variants={container} initial="hidden" animate="show" className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 mb-8" data-id="element-111">
      {METRICS.map(metric => <motion.div key={metric.id} variants={item} className="bg-white rounded-xl p-5 soft-shadow border-t-[3px] border-accent relative overflow-hidden" style={{
      borderTopColor: 'var(--accent-color)'
    }} data-id="element-112">
          <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-113">
            {metric.label}
          </h3>
          <div className="text-2xl md:text-3xl font-bold text-gray-900 tracking-tight mb-2" data-id="element-114">
            {metric.value}
          </div>
          <div className={`text-xs font-medium flex items-center gap-1 ${metric.trendUp === true ? 'text-green-600' : metric.trendUp === false ? 'text-red-600' : 'text-gray-400'}`} data-id="element-115">
            {metric.trend}
          </div>
        </motion.div>)}
    </motion.div>;
}